<template>
  <div class="overlay">
    <div :class="['content-container', { loading }]">
      <slot />
    </div>
    <div class="loader-container" v-show="loading">
      <ui-loader />
      <slot name="loader-content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: { type: Boolean, default: false }
  }
};
</script>

<style scoped lang="scss">
.overlay {
  position: relative;
}
.content-container {
  &.loading {
    pointer-events: none;
    opacity: 0.5;
  }
}
.loader-container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 0;
  transform: translate(-50%, -50%);
}
</style>
